import React, { useState } from 'react';
import PropTypes from 'prop-types';

interface IProps {
  id: string,
  value: boolean,
  callBack: any,
}

export default function InputBoolean(props: IProps) {
  const [value, setValue] = useState(props.value);

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    setValue(event.target.checked);

  const onBlur = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.callBack(event.target.checked);
    setValue(event.target.checked);
  }

  return (
      <input
        key={`input-${props.id}`}
        type="checkbox"
        onChange={onChange}
        onBlur={onBlur}
        checked={value} />
    );
}

InputBoolean.propTypes = {
  key: PropTypes.string,
  value: PropTypes.bool,
  callBack: PropTypes.func,
};